﻿import '../Styles/global-styles.scss';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';
import './CustomControls';
import { detect as detectBrowser } from 'detect-browser';
import { JsPlumbEditor } from './JsPlumb';

import { PageUnloadUtilities } from './pageUnloadUtilities';
import { AuthUtilities } from './authUtilities';
import { ChangeLogUtilities } from './changeLogUtilities';
import { DateUtilities } from './dateUtilities';
import { DialogUtilities } from './dialogUtilities'; 
import { DnDUtilities } from './dndUtilities';
import { DocumentUtilities } from './documentUtilities';
import { DownloadUtilities } from './downloadUtilities';
import { ElementUtilities } from './elementUtilities';
import { ZenDropdown } from './zenDropdown';
import { ZenAvatar } from './zenAvatar';

/**
ZenUI contains methods namespaced into each of these imported sub-class.

This is both to avoid polluting the Window object (Which should only contain the 'ZenUI' superglobal) and 
prevent bloat in this file by dedicating functions to 'namespaced' sub-classes. For example, to provide 
the block unsaved changes dialog, you would access 'ZenUI.documentUtilities.blockUnsavedChanges(true)'.

Note that the variable names on this class are what other JS/Blazor would call - the class names are similar
purely for convenience.
*/
class ZenUI {
    constructor() {
        // Added to assist with browser/OS specific CSS overrides

        const browser = detectBrowser();
        if (browser !== null) {
            console.log(`Detected the following browser information: `, browser);

            document.body.classList.add(browser.name.replace(/\s/gi, "_").toLowerCase());

            if (browser.os != null) {
                document.body.classList.add(browser.os.replace(/\s/gi, "_").toLowerCase());

                const spaceIndex = browser.os.indexOf(" ");
                if (spaceIndex > 0) {
                    document.body.classList.add(browser.os.substring(0, spaceIndex).toLowerCase());
                }
            }
        }
    }

    JsPlumbEditor = JsPlumbEditor;
    
    authUtilities = new AuthUtilities();
    changeLogUtilities = new ChangeLogUtilities();
    dateUtilities = new DateUtilities();
    dialogUtilities = new DialogUtilities();
    dndUtilities = new DnDUtilities();
    documentUtilities = new DocumentUtilities();
    downloadUtilities = new DownloadUtilities();
    elementUtilities = new ElementUtilities();
    pageUnloadUtilities = new PageUnloadUtilities();
    zenDropdown = new ZenDropdown();
    zenAvatar = new ZenAvatar();

    logToConsole = function (message, type = "error") {
        switch (type) {
            case "error":
                console.error(message);
                break;
            case "warning":
                console.warn(message);
                break;
            case "success":
            case "info":
            default:
                console.log(message);
        }
    };
}

// Add's the ZenUI class to the 'window' global object.
declare global {
    interface Window {
        ZenUI: ZenUI
    }
}
window.ZenUI = new ZenUI();

console.log("Trident.Zen.UI JavaScript Loaded");